<div class="transacoes-connecttef">
  <header class="queue-page-header">
    <div class="queue-title-group">
      <span class="queue-title-icon"><i class="fas fa-clipboard-check"></i></span>
      <div>
        <h4>Fila operacional ConnectTEF</h4>
        <p>Confira e resolva pagamentos que precisam de atenção.</p>
      </div>
    </div>
    <button class="btn btn-outline-primary" (click)="carregue()" [disabled]="carregando">
      <i class="fas fa-sync mr-1" [ngClass]="{'fa-spin': carregando}"></i> Atualizar
    </button>
  </header>

  <div class="alert alert-danger" *ngIf="erro"><i class="fas fa-exclamation-circle mr-2"></i>{{erro}}</div>
  <div class="alert alert-success" *ngIf="mensagem"><i class="fas fa-check-circle mr-2"></i>{{mensagem}}</div>

  <section class="queue-summary">
    <div class="queue-summary-number">{{pendenciasFiltradas.length}}</div>
    <div><strong>{{pendenciasFiltradas.length === 1 ? 'pendência encontrada' : 'pendências encontradas'}}</strong><span>As resoluções ficam registradas para auditoria.</span></div>
    <div class="queue-filters">
      <div class="form-group mb-0">
        <label for="filtroTipoConnectTef">Tipo</label>
        <select id="filtroTipoConnectTef" class="form-control" [(ngModel)]="filtroTipo">
          <option value="">Todos os tipos</option>
          <option value="TRANSACAO_INDETERMINADA">Resultado indefinido</option>
          <option value="POS_PROCESSAMENTO_PENDENTE">Pós-processamento</option>
          <option value="CALLBACK_CONFLITANTE">Callback conflitante</option>
          <option value="BLOQUEIO_FISCAL_ADQUIRENTE">Pendência fiscal</option>
          <option value="ESTORNO_PENDENTE">Estorno pendente</option>
          <option value="FATURAMENTO_TERMINAIS">Faturamento</option>
        </select>
      </div>
      <div class="form-group mb-0">
        <label for="filtroStatusConnectTef">Situação</label>
        <select id="filtroStatusConnectTef" class="form-control" [(ngModel)]="filtroStatus">
          <option value="">Todas as situações</option>
          <option value="INDETERMINATE">Resultado indefinido</option>
          <option value="APPROVED">Aprovado</option>
          <option value="REVERSAL_PENDING">Estorno pendente</option>
          <option value="SENT">Aguardando terminal</option>
        </select>
      </div>
    </div>
  </section>

  <div class="queue-list">
    <article class="queue-item" *ngFor="let item of pendenciasFiltradas" [ngClass]="classePendencia(item)">
      <div class="queue-item-marker"><i class="fas" [ngClass]="iconePendencia(item)"></i></div>
      <div class="queue-item-content">
        <header class="queue-item-header">
          <div class="queue-item-title">
            <div class="queue-badges">
              <span class="queue-type-pill" *ngFor="let tipo of item.tipos">{{rotuloTipo(tipo)}}</span>
            </div>
            <strong>{{item.identificacao ? 'Pagamento com pendência' : 'Sincronização da assinatura'}}</strong>
            <code *ngIf="item.identificacao" [title]="item.identificacao">{{item.identificacao}}</code>
          </div>
          <div class="queue-item-meta">
            <span *ngIf="item.atualizadoEm"><i class="far fa-clock mr-1"></i>{{item.atualizadoEm | date:'short'}}</span>
          </div>
        </header>

        <div class="queue-status-grid">
          <div *ngIf="item.statusFinanceiro"><small>Situação do pagamento</small><strong>{{rotuloStatusFinanceiro(item.statusFinanceiro)}}</strong></div>
          <div *ngIf="item.statusFiscal"><small>Situação fiscal</small><strong>{{rotuloStatusFiscal(item.statusFiscal)}}</strong></div>
          <div *ngIf="item.identificacao"><small>Valor</small><strong>{{item.valor | currency:'BRL'}}</strong></div>
          <div *ngIf="item.identificacao"><small>Autorização</small><strong>{{item.codigoAutorizacao || 'Não informada'}}</strong></div>
          <div *ngIf="item.identificacao"><small>NSU</small><strong>{{item.nsu || 'Não informado'}}</strong></div>
        </div>

        <div class="queue-message" *ngIf="item.erroSanitizado && item.tipo !== 'FATURAMENTO_TERMINAIS'">
          <i class="fas fa-info-circle"></i><span>{{item.erroSanitizado}}</span>
        </div>
        <div class="queue-message" *ngIf="item.tipo === 'FATURAMENTO_TERMINAIS'">
          <i class="fas fa-info-circle"></i>
          <span>Terminais ativos: {{item.quantidadeTerminaisAtivos}} · Quantidade assinada: {{item.quantidadeAssinada}}. {{item.erroSanitizado || 'A reconciliação automática corrigirá a divergência.'}}</span>
        </div>

        <details class="queue-technical" *ngIf="item.payloadBruto">
          <summary>Ver dados técnicos</summary>
          <pre>{{item.payloadBruto | json}}</pre>
        </details>

        <div class="queue-resolution" *ngIf="podeResolver(item)">
          <div class="queue-resolution-heading">
            <i class="fas fa-user-check"></i>
            <div><strong>Registrar resolução</strong><span>Informe o que foi confirmado fora do sistema.</span></div>
          </div>
          <div class="queue-resolution-grid">
            <div class="form-group mb-0">
              <label>Ação</label>
              <select class="form-control" [(ngModel)]="item.resolucao.acao">
                <option *ngIf="item.statusFinanceiro === 'INDETERMINATE'" value="REJEITAR">Confirmar como rejeitado</option>
                <option *ngIf="item.statusFinanceiro === 'INDETERMINATE'" value="ERRO">Encerrar com erro</option>
                <option *ngIf="item.statusFinanceiro === 'INDETERMINATE'" value="APROVAR">Confirmar como aprovado</option>
                <option *ngIf="item.statusFinanceiro !== 'INDETERMINATE'" value="REPROCESSAR">Tentar processamento novamente</option>
              </select>
            </div>
            <div class="form-group mb-0">
              <label>Justificativa</label>
              <input class="form-control" maxlength="500" [(ngModel)]="item.resolucao.justificativa" placeholder="Descreva a conferência realizada">
            </div>
            <div class="form-group mb-0">
              <label>Protocolo ou evidência</label>
              <input class="form-control" maxlength="2000" [(ngModel)]="item.resolucao.evidencia" placeholder="Número do protocolo, comprovante ou consulta">
            </div>
            <button class="btn btn-primary" (click)="resolva(item)" [disabled]="item.resolvendo">
              <i class="fas fa-check mr-1"></i> Registrar
            </button>
          </div>
        </div>
      </div>
    </article>
  </div>

  <div class="queue-empty" *ngIf="!carregando && !pendenciasFiltradas.length">
    <span><i class="fas fa-check-circle"></i></span>
    <strong>Nenhuma pendência operacional</strong>
    <p>Os pagamentos integrados estão conciliados.</p>
  </div>
</div>
